import { GAME_WIDTH, GAME_HEIGHT } from '../config.js';
import { iconText } from './iconText.js';
import { tokenize } from './icons.mjs';
import { pinToCamera } from './pin.mjs';
import { isTouchDevice } from './isTouchDevice.js';

// A short message over a rounded dark pill. Messages may carry {icon} tokens (ui/icons.mjs);
// older strings that still hold emojis are tokenized on the way in.
export function showToast(scene, message, durationMs = 2500) {
  const x = GAME_WIDTH / 2;
  // High enough to clear the bottom-centre DOM chat palette / free-text bar, which is
  // fixed to the window bottom and overlays roughly the lowest ~70 logical px.
  const y = GAME_HEIGHT - 150;
  // Phones show the game at ~half size: 22 px came out ~10 CSS px, too small to read at a glance.
  const touch = isTouchDevice();
  const text = iconText(scene, 0, 0, tokenize(String(message ?? '')), {
    fontFamily: 'system-ui', fontSize: touch ? '34px' : '22px', color: '#ffffff', align: 'center',
    wordWrap: { width: GAME_WIDTH - 200 },
  }).setOrigin(0.5);
  const w = text.width + (touch ? 44 : 32), h = text.height + (touch ? 26 : 20);
  const bg = scene.add.graphics();
  bg.fillStyle(0x000000, touch ? 0.85 : 0.8);
  bg.fillRoundedRect(-w / 2, -h / 2, w, h, Math.min(16, h / 2));
  // Pinned to the camera, not the world: in a scrolling scene (the street) a world-space
  // toast sits at x = 640 of the map, i.e. off screen for everything but the far left end
  // — which silently swallowed every message shown while driving. Toasts aren't
  // interactive, so scrollFactor 0 has no hit-testing catch (unlike a modal container).
  const toast = pinToCamera(scene.add.container(x, y, [bg, text])).setDepth(1000);

  scene.tweens.add({
    targets: toast,
    alpha: 0,
    delay: durationMs - 400,
    duration: 400,
    onComplete: () => toast.destroy(),
  });
  return toast;
}
